import { useEffect } from "react";

// HelpScout Beacon intentionally disabled.
//
// The configured beacon id (c8430dd6-2a64-4b61-962f-ed18a2da7ea4) now returns 404
// from HelpScout (beacon removed / subscription lapsed). On init the failing widget
// retried and stormed the browser's main thread, freezing the whole web app on the
// loading screen (mobile is unaffected — it has no web Beacon). Until a valid, live
// beacon id is available, do not load it. To re-enable, restore the previous
// initHelpscout() implementation with a working beacon id.
export default function useHelpScout(community) {
  useEffect(() => {
    // no-op — Beacon disabled
  }, [community]);
}
